
import * as types from './types';

export const init = ({ commit, rootGetters }, { content, hasBundle }) => {
  commit(types.INIT, { content, hasBundle, rootGetters });
};

export const update = ({ commit, rootGetters }, { path, quantity, uniqueInNamespace, provenance }) => {
  commit(types.UPDATE, { path, quantity, uniqueInNamespace, provenance, rootGetters });
};

export const resetNamespace = ({ commit }, namespace) => {
  commit(types.RESET_NAMESPACE, namespace);
};

export const setPreviousContent = ({ commit }) => {
  commit(types.SET_PREVIOUS_CONTENT);
};

export default {
  init,
  update,
  resetNamespace,
  setPreviousContent
};



// WEBPACK FOOTER //
// ./src/store/modules/cart/actions.js